<script setup>
import { useNotificationStore } from '@/stores/notification'

const notificationStore = useNotificationStore()
</script>

<template>
  <v-app>
    <router-view></router-view>
    <v-snackbar 
      auto-width 
      v-model="notificationStore.visible" 
      :timeout="2000" 
      :color="notificationStore.type"
      class="content-top-notification"
      location="top"
    >
      {{ notificationStore.message }}
    </v-snackbar>
  </v-app>
</template>

<style>
.content-top-notification {
  top: 64px !important; /* Default height o f v-app-bar */
  z-index: 1000;
}

/* Adjust for different screen sizes */
@media (max-width: 960px) {
  .content-top-notification {
    top: 56px !important; /* Smaller app bar on mobile */
  }
}
</style>
